import { useCallback, useEffect, useState } from "react";
import { PublicPageStyle } from "../../constants/styles";
import {
  AllDeviceDataType,
  RouterType,
  SiteCategoryType,
} from "../../constants/types";
import AllDeviceTemplate from "../templates/AllDeviceTemplate";
import { getAllDeviceList, getGroupData } from "../../api/device";
import { getSiteList } from "../../api/common";

const AllDevicePage = (props: RouterType) => {
  const [data, setData] = useState<AllDeviceDataType>({
    total: {
      total: 0,
      disConnected: 0,
    },
    list: [],
    all: [],
  });
  const [render, setRender] = useState<boolean>(false);
  const [categories, setCategories] = useState<SiteCategoryType[]>([]);
  const [page, setPage] = useState<number>(0);
  const [options, setOptions] = useState({
    siteNo: "all",
    type: "all", // EPLUS, PLANT, LEAF, EP, WG, SC
  });

  const getData = useCallback(async () => {
    const group = await getGroupData();
    const device = await getAllDeviceList(
      1,
      10000,
      options.siteNo,
      options.type
    );

    setData({ ...group, all: device });
  }, [options]);

  const getCategoryList = useCallback(async () => {
    const category = await getSiteList();
    setCategories(category);
  }, []);

  useEffect(() => {
    getData();
  }, [props.render, render, options]);

  useEffect(() => {
    setPage(0);
  }, [options]);

  useEffect(() => {
    getCategoryList();
  }, []);
  return (
    <PublicPageStyle>
      <AllDeviceTemplate
        data={data}
        categories={categories}
        option={{ options, setOptions }}
        render={{ render, setRender }}
        page={{ state: page, setState: setPage }}
      />
    </PublicPageStyle>
  );
};

export default AllDevicePage;
